/** Business-dialect overrides. Sparse: a missing key falls back to en. */
export const glossary = {
    account: {
        singular: 'business',
        plural: 'businesses',
        aliases: '',
        description: 'A business that uses the billing platform.',
    },
    client: {
        description: 'A person or organisation the business bills for its work.',
    },
    clientProject: {
        singular: 'project',
        plural: 'projects',
        description: 'A project the business is delivering for a client.',
    },
    clientProjectActivity: {
        description: 'A time entry or expense recorded against a project.',
    },
    user: {
        description: 'A person who uses the platform, typically a member of the business.',
    },
    fee: 'service',
    disbursement: 'expense',
};
